export class FormaIngresso  {
    id: number;    
    descricao: string;
    indEnem: boolean;
}